<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO号</label>
            <span class="weui-form-preview__value">{{ item.dt_code }}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{item.dt_cop}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dt_delivery}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">追踪日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.createTime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">序号</label>
            <span class="weui-form-preview__value">{{item.detail_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料编号</label>
            <span class="weui-form-preview__value">{{item.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_orispeccode">
            <label class="weui-form-preview__label">客户物料型号</label>
            <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_spec">
            <label class="weui-form-preview__label">客户物料规格</label>
            <span class="weui-form-preview__value">{{item.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_brand">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{item.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{item.dt_qty}} {{item.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">未交数量</label>
            <span class="weui-form-preview__value">{{item.dt_nqty}} {{item.pr_unit}}</span>
          </div>
        </div>
      </div>

      <collapse class="form-preview weui-form-preview" title="回复交期详情" v-if="item.replyList && item.replyList.length">
        <reply-list :replyList="item.replyList"></reply-list>
      </collapse>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="item.allowReply">
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="onOpenReply">回复</div>
    </div>

    <div v-if="showReplyInput">
      <div class="weui-mask weui-transition"></div>
      <div class="weui-half-screen-dialog weui-transition">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__main">
            <div class="weui-half-screen-dialog__title">交期回复</div>
          </div>
        </div>
        <div
          class="weui-half-screen-dialog__bd"
          style="padding-top: 12px; max-height: 230px; overflow-y: scroll;"
        >
          <div
            class="weui-cells__group"
            v-for="(item, xindex) in splitList"
            :key="xindex"
          >
            <div class="weui-cells__title">
              <span>批次{{ xindex + 1 }}</span>
              <a
                href="javascript:;"
                class="header-tool"
                @click="removeItem(xindex)"
              >
                <span>删除</span>
              </a>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{"数量"}}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input text-right"
                  type="text"
                  v-model="item.qty"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field
              :label="'交货日期'"
              v-model="item.delivery"
              body-cls="text-right"
            />
            <a
              href="javascript:"
              v-if="xindex == splitList.length - 1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </div>
        </div>
        <div class="weui-half-screen-dialog__ft">
          <div class="weui-half-screen-dialog__btn-area">
            <div class="weui-btn weui-btn_primary" @click="onReply">确认</div>
            <div class="weui-btn weui-btn_default" @click="showReplyInput = false">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import ReplyList from "@/components/button/ReplyList.vue";
import Collapse from "@/components/Collapse.vue";

export default {
  components: {
    DateField,
    ReplyList,
    Collapse
  },
  data() {
    var item = this.$route.params.item || {}
    return {
      item,
      showReplyInput: false,
      splitList: [
        {
          delivery: item.dt_delivery || "",
          qty: item.dt_nqty || 0
        }
      ]
    }
  },
  methods: {
    onOpenReply() {
      this.showReplyInput = true
    },
    onReply() {
      let me = this, splitList = me.splitList;
      if (!splitList.length) {
        me.$weui.topTips('请填写数量和交期', 2000);
        return;
      }
      for (var item of splitList) {
        if (!item.qty) {
            me.$weui.topTips('请填写数量', 2000);
            return;
        } else if (!item.delivery) {
            me.$weui.topTips('请填写交期', 2000);
            return;
        }
      }

      let jsonData = {
        pdid: me.item.dt_purcdetailid,
        pucode: me.item.dt_code, 
        splitList, 
        type: me.item.dt_type
      }

      me.$loading({
        url: "/api/purchase/purchaseReply/save",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("回复成功", 2000);
          me.showReplyInput = false
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    addItem() {
      var me = this,
        splitList = me.splitList;
      splitList.push({
        delivery: "",
        qty: null
      });
    },
    removeItem(i) {
      var me = this,
        splitList = me.splitList;

      if(splitList.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000)
        return
      }

      splitList.splice(i, 1);
    }
  }
}
</script>